export const { toggle, browser, hardcore, dom } = window.o_util;
export const { breakpoint } = window.o_global;
